SlideView  = require("views/slide")
{ DraggyView } = require("views/components/draggy")
Preload    = require("lib/preload")

class ImageSliderView extends SlideView
  template: require("./template")

  currentIndex: 0

  events: 
    "iostap": "onTap"

    "click .btn-done": "submit"
    "click .btn-down": "scrollNext"
    "click .btn-up": "scrollPrev"

  submit: (e) ->
    e.stopImmediatePropagation()
    super arguments...
  
  scrollNext: ->
    index = @currentIndex

    index++
    
    index = Math.max(Math.min(index, @options.data.items.length - 1), 0)
    @draggy?.reset { y: -index * @draggy.offset.height }

  scrollPrev: ->
    index = @currentIndex

    index--
    
    index = Math.max(Math.min(index, @options.data.items.length - 1), 0)
    @draggy?.reset { y: -index * @draggy.offset.height }

  onTap: (e) ->
    return if e.target instanceof HTMLAnchorElement or e.target.classList.contains("btn") or e.target.classList.contains("icon")

    index = @currentIndex

    if (e.detail?.clientY) > @el.offsetHeight / 2
      index++
    else
      index--

    index = Math.max(Math.min(index, @options.data.items.length - 1), 0)

    @draggy?.reset { y: -index * @draggy.offset.height }

  serialize: ->
    data = super arguments...

    @options.data.items = data.items =
      (data.items or []).filter (m) ->
        m.content or (m.caption and m.caption.length > 0)

    for item in data.items
      item.contentType ?= "image"
      item.captionStyle ?= "Default"
      item.imagePosition ?= "Middle"

    if data.items.length <= 1
      window.setTimeout (=> @setState "touched"), 0

    data.hasPrompt = true
    data.arrows ?= true

    data

  beforeShow: ->
    if @options.data.arrows
      @trigger("hide", { arrows: false })

  show: (index = 0) ->
    @draggy?.undelegateEvents()
    @draggy = null

    el = @findOne(".carousel")
    @setEl el.firstChild, "scroller" if el
    @setEl @findOne(".btn-up"), "btn-up"
    @setEl @findOne(".btn-down"), "btn-down"
    @setEl @findOne("#done-btn"), "done-btn"
    @setEl @findOne("#prompt"), "prompt"

    @getEl("done-btn").hidden = "true"

    if @options.data.items.length > 1
      len = (@options.data.items.length - 1)
      min = -el.offsetHeight * len

      @draggy  = new DraggyView {
        el: el
        minY: min
        maxY: 0
        lock: "x"
        allowPropagation: true
      }

      @listenTo @draggy, "drag", @onDrag
      @listenTo @draggy, "drop", @onDrop

      @draggy.reset { y: -@draggy.offset.height * Math.min(index, len) }

      @getEl("btn-up").setAttribute("aria-hidden", "true")
      @getEl("btn-down").setAttribute("aria-hidden", "false")

    else if item = @getEl("scroller").firstChild
      item.classList.add("active")
      item.setAttribute("aria-hidden", "false")
      for el in item.children
        @transform el, {
          opacity: 1
          transition: "all 300ms"
        }
      @getEl("btn-up").setAttribute("aria-hidden", "true")
      @getEl("btn-down").setAttribute("aria-hidden", "true")

    
    @trigger "ui", { lightbox: @options.data.items[0]?.color or false }

    @listenTo this, "resize", @onResize
    @onResize()

  onDrag: (draggy, isInitial) ->
    window.Backbone.trigger("canceltap")

    transition = if isInitial then "all 300ms" else "none"

    @transform @getEl("scroller"), {
      y: @getScrollDist(draggy)
      transition: transition
    }

    @updateChildren(draggy, transition)

  onDrop: (draggy, isReset) ->
    if isReset
      transition    = if @currentIndex? then "all 300ms" else ""
      @currentIndex = Math.floor(-draggy.y / draggy.offset.height)

      @transform @getEl("scroller"), {
        y: @getScrollDist(draggy)
        transition: transition
      }

      @updateChildren(draggy, transition)

    else
      y = draggy.velocity.y
      m = 0.9
      func =
        if y < -m then "ceil"
        else if y > m then "floor"
        else "round"

      step = Math[func](Math.min(draggy.y / draggy.offset.height, 1))
      draggy.reset { y: step * draggy.offset.height }

    total = @options.data.items.length - 1

    currentItem = @options.data.items[@currentIndex or 0]

    @trigger "ui", { lightbox: currentItem?.color or false }

    @setState currentItem.position?.toLowerCase() or "none", "caption-position"
    prevButton = @getEl("btn-up")
    nextButton = @getEl("btn-down")

    prevButton.classList.toggle "active", @currentIndex > 0
    if @currentIndex > 0
      prevButton.setAttribute("aria-hidden", "false")
    else
      prevButton.blur()
      prevButton.setAttribute("aria-hidden", "true")

    nextButton.classList.toggle "active", @currentIndex < total
    if @currentIndex < total
      nextButton.setAttribute("aria-hidden", "false")
    else
      nextButton.blur()
      nextButton.setAttribute("aria-hidden", "true")

    if @currentIndex is total
      @setState("touched")
      @getEl("done-btn").removeAttribute("hidden")
      @getEl("prompt").hidden = "true"

  updateChildren: (draggy, transition) ->
    { height } = draggy.offset

    for child, i in @getEl("scroller").children
      child.classList.toggle("active", i is @currentIndex)
      child.classList.toggle("transition", transition isnt "")

      if transition
        @transition(child, transition, true)

      if i is @currentIndex
        child.setAttribute("aria-hidden", "false")
      else
        child.setAttribute("aria-hidden", "true")

      o = Math.abs(draggy.y + (i * height)) / height

      for item, i in child.children when not item.classList.contains "caption"
        @transform item, {
          y: -o * height / (i + 1) / 3
          opacity: 1 - o
          transition: transition
        }

  getScrollDist: (draggy) ->
    "#{
      draggy.y / draggy.offset.height / @options.data.items.length * 100
    }%"

  onResize: ->
    if scroller = @getEl("scroller") and @draggy
      @draggy.y = -@currentIndex * @draggy.offset.height
      @draggy.options.minY =
        -@draggy.el.offsetHeight * (@options.data.items.length - 1)
      @draggy.getOffset()

  refresh: (params) ->
    for next, i in params.data.items
      prev = @options.data.items[i]

      # if new section prev does not exist
      if prev
        for key, val of next
          if prev[key] is undefined or prev[key] isnt val
            changed = i
          break if changed?
      else
        changed = i
      break if changed?

    super arguments...

    if @draggy
      @draggy.undelegateEvents()
      @draggy = @currentIndex = null

    @show(changed)

  screenshot: ->
    @currentIndex = -1

    new Promise (resolve, reject) =>
      getPages = (images = []) =>
        if @currentIndex < @options.data.items.length - 1
          @currentIndex++

          if @options.data.items.length > 1
            @draggy?.reset { y: -@currentIndex * @draggy.offset.height }

          @collateScreenshots(images)
            .then(getPages)
            .catch(reject)
        else
          resolve(images)

      getPages()

module.exports = ImageSliderView
